import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BasicTable from "../../../Components/Table/Material/index.js";
import useApi from "../../../Hooks/useApi.js";
import { usePagination } from "../../../Hooks/usePagination.js";
import Modal from "../../../Components/Modal/index.js";
import ManageKIICityList from "../../../Components/Modal/KIICityListModal.js";
import { useModal } from "../../../Hooks/useModal.js";
import useWindowWidth from "../../../Hooks/useWindowWidth.js";
import { handleApiError } from "../../../Helpers/ErrorHandler.js";

import Common from "../../../Components/Layouts/Common.js";
import ButtonToolbar from "../../Shared/ButtonToolbar.js";

const ManageKII = () => {
  const { request } = useApi();
  const { t } = useTranslation();
  const [kiiData, setkiiData] = useState();
  const [selectedKII, setSelectedKII] = useState(null);
  const paginateProps = usePagination();
  const { isOpen, closeModal, openModal } = useModal();

  const fetchKiiList = useCallback(async () => {
    try {
      const response = await request(
        "GET",
        `/v1/kii/list?offset=${paginateProps.page}&limit=${paginateProps.rowsPerPage}`,
        {},
        "kii_service"
      );

      setkiiData(
        response.content.map((el, index) => {
          return {
            ...el,
            assigned_cities: el.assignedCities,
            submitted_cities: el.submittedCities,
            assigned_date: el.startDate,
            end_date: el.endDate,
          };
        })
      );
      paginateProps.setTotalData(response.totalElements);
    } catch (error) {
      console.log(error);
      handleApiError(error);
    }
  }, [request, paginateProps.page, paginateProps.rowsPerPage, paginateProps.setTotalData]);

  useEffect(() => {
    fetchKiiList();
  }, [fetchKiiList]);

  const columns = [
    {
      id: "name",
      label: "KII Title" || t("KII.title"),
      minWidth: 170,
    },
    {
      id: "assigned_cities",
      label: "#Assigned Cities",
      minWidth: 100,
      align: "center",
    },
    {
      id: "submitted_cities",
      label: "#Submitted Cities",
      minWidth: 100,
      align: "center",
    },
    {
      id: "assigned_date",
      label: "Assignment Date",
      minWidth: 100,
      align: "center",
      // renderCell: (row) => {
      //   return new Date(row.assigned_date)?.toLocaleDateString();
      // },
    },
    {
      label: "End Date",
      id: "end_date",
      minWidth: 100,
      align: "left",
      // renderCell: (row) => {
      //   return new Date(row.end_date)?.toLocaleDateString();
      // },
    },
    {
      id: "action",
      label: "Actions",
      minWidth: 150,
      align: "center",
      renderCell: (row) => (
        <ActionButtonPanel
          row={row}
          handleCityList={(e) => {
            e.stopPropagation();
            setSelectedKII({ kiiId: row.kiiId, kiiName: row.name });
            openModal();
          }}
        />
      ),
    },
  ];

  const windowWidth = useWindowWidth();
  return (
    <div className=" bg-white  relative h-full">
      <Common headline={" Manage KII"}>
        <div className="py-2 flex items-center justify-between ">
          <div className="space-x-2">
            <ButtonToolbar title={"Add New KII"} navigateURL={"/create-kii"}  />
          </div>
        </div>

        <BasicTable
          paginateProps={paginateProps}
          columns={columns}
          data={kiiData}
          maxHeight={15000}
        />

        <Modal
          isOpen={isOpen}
          onClose={closeModal}
          style={{ width: windowWidth >= 768 ? "70vw" : "90vw" }}
        >
          <ManageKIICityList kii={selectedKII} />
        </Modal>
      </Common>
    </div>
  );
};

const ActionButtonPanel = ({ row, handleCityList }) => {
  return (
    <div className="inline-flex flex-col flex-wrap gap-2 justify-center text-xs">
      <Link
         to={"/view-kii-questionnaire"}
         state={{
           id: row.questionnaireId,
           viewType: "view",
         }}
      >
        <button
          className={`w-[130px] bg-[#1976d2] border border-gray-300  text-white rounded-md flex items-center justify-center p-1.5`}
        >
         View Mapped Questionnaire
        </button>
      </Link>

      <button
        onClick={handleCityList}
        className={`w-[130px] bg-[#1976d2] border border-gray-300  text-white rounded-md flex items-center justify-center p-1.5`}
      >
        City List
      </button>

      <Link
        to={"/kii-data-submission-city-list"}
        state={{
          kiiId: row.kiiId,
          kiiName: row.name,
          questionId: row.questionnaireId,
        }}
      >
        <button
          className={`w-[130px] bg-[#1976d2] border border-gray-300  text-white rounded-md flex items-center justify-center p-1.5`}
        >
          Data Submission
        </button>
      </Link>
    </div>
  );
};

export default ManageKII;
